module.exports = __webpack_public_path__ + "static/media/csk-mobile-411x93-80.430e9cac.webp";